import { getInitialLocale } from '@/@core/utils/getInitialLocale';
import { createStoreId } from '@/stores/createStoreId';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export type Locale = 'en' | 'de';

export const useWorkspaceStore = defineStore(
  createStoreId('workspace'),
  () => {
    const currentLocale = ref<Locale>(getInitialLocale());
    const isSidebarOpen = ref(true);
    const showPrivacyPolicyInfo = ref(true);
    const wasClosedByViewport = ref(false);

    const setAppLocale = (newLocale: Locale) => {
      currentLocale.value = newLocale;
    };

    const toggleSidebar = (isExpanded: boolean, reason: 'user' | 'viewport') => {
      isSidebarOpen.value = isExpanded;

      // Track if sidebar was closed due to viewport change
      if (!isExpanded && reason === 'viewport') {
        wasClosedByViewport.value = true;
      } else if (isExpanded || reason === 'user') {
        wasClosedByViewport.value = false;
      }
    };

    return {
      setAppLocale,
      toggleSidebar,
      currentLocale,
      isSidebarOpen,
      showPrivacyPolicyInfo,
      wasClosedByViewport,
    };
  },
  {
    persist: true,
  }
);
